import React from 'react'
import { post, put, upload } from '../modules/fetch'
import Image from './Image'
import Input from './Input'
import Icon from './Icon'
import FileInput from './FileInput'
import { If, debounce, urlText } from '../modules/helpers'
import { FRONT_STORE_ARRAY } from '../constants/'

export default class ImageEdit extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            image: this.props.content || {},
            base_64: '',
            sucess: false,
            error: false,
        }
    }

    componentDidMount() {
        if (!this.props.content || (this.props.content && !this.props.content.id)) {
            post('image', { article_id: this.props.article_id }).then(
                (r) => console.log(this.state.content, r) || this.setImageContent({ ...this.state.image, ...r })
            )
        }
        // this.setImageContent({})
        if (!this.props.content.width) {
            console.log('missing width: ', this.props.content.id)
        }
    }

    setImageContent = (image) => {
        // console.log({image})
        let img = {
            id: image.id || this.state.image.id,
            path: typeof image.path !== 'undefined' ? image.path : this.state.image.path,
            src: typeof image.src !== 'undefined' ? image.src : this.state.image.src,
            alt: typeof image.alt !== 'undefined' ? image.alt : this.state.image.alt,
            href: typeof image.href !== 'undefined' ? image.href : this.state.image.href,
            width: typeof image.width !== 'undefined' ? image.width : this.state.image.width,
            height: typeof image.height !== 'undefined' ? image.height : this.state.image.height,
        }
        this.setState({ image: { ...img, temp_src: img.src, src: this.state.image.src } }, () => this.props.onChange({ target: { value: img } }))
        // this.setState({ image: { ...img, temp_src: img.src, src: this.state.image.src } })
        if (this.props.site_id) {
            img.site_id = this.props.site_id
        }
        ;(typeof image.src === 'undefined' || image.src) && this.syncWithDB(img)
    }

    syncWithDB = debounce((img) => {
        console.log(img)
        put('image/' + img.id, img).then((r) => {
            // let filtered_image = { id: r.id, path: r.path, alt: r.alt, href: r.href || img.href, width: r.width, height: r.height }
            let filtered_image = { id: r.id, path: r.path, href: r.href || img.href, width: r.width, height: r.height }
            this.setState(
                (current) => ({ image: { ...this.state.image, ...filtered_image, alt: current.image.alt, src: current.image.src || r.src } }),
                () => {
                    this.props.onChange({ target: { value: { ...this.state.image, src: r.src } } })
                }
            )
        })
    }, 1000)

    onUploadChange = (e) => {
        let files = e.target.files || e.dataTransfer.files
        console.log(e.target.files)
        if (!files.length) {
            return
        }
        this.createImage(files[0])
    }

    createImage = (file) => {
        console.log('createImage')
        let reader = new FileReader()
        reader.onload = (e) => {
            this.setState({ base_64: e.target.result, image_name: file.name }, this.fileUpload)
        }
        reader.readAsDataURL(file)
    }

    fileUpload = async () => {
        upload('image-upload', {
            id: this.props.content.id,
            site_id: this.props.site_id || undefined,
            image_name: this.state.image_name,
            file: this.state.base_64.substr(this.state.base_64.indexOf('base64,') + 7),
        })
            .then((r) => r.json())
            .then((r) => {
                console.log(r)
                this.setImageContent(r)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    getEditableFileName = (filename) => {
        if (!!~filename?.lastIndexOf('-')) {
            return filename?.substring(0, filename?.lastIndexOf('-'))
        } else {
            return filename?.substring(0, filename?.lastIndexOf('.'))
        }
    }
    getStaticPartInFilename = (filename) => {
        if (!!~filename.lastIndexOf('-')) {
            return filename.substring(filename.lastIndexOf('-'))
        } else {
            return filename.substring(filename.lastIndexOf('.'))
        }
    }

    render() {
        const { base_64, image } = this.state
        const caption_content =
            (image.alt && image.href && (
                <a href={image.href} target="_blank" rel="noopener noreferrer">
                    {image.alt}
                </a>
            )) ||
            image.alt ||
            null
        const caption = (caption_content && <figcaption>{caption_content}</figcaption>) || null

        const caption_error = !image.alt
        const provider_url = FRONT_STORE_ARRAY.find((f) => f.locale === this.props.article?.site?.locale)?.url
        const provider_error =
            image.href && !image.href.includes(provider_url) && !image.href.includes(this.props.article?.site?.url) && image.href.substring(0, 1) !== '/'
        const tag_error =
            (image.href &&
                this.props.article?.site?.tracking_id &&
                !~image.href.indexOf(this.props.article.site.tracking_id) &&
                !~image.href.indexOf('//' + this.props.article.site.url + '/')) ||
            image.href?.includes('{{link_id}}')
        const filename_error =
            this.getEditableFileName(image.temp_src || image.src)?.length === 11 && !~this.getEditableFileName(image.temp_src || image.src).indexOf('-')
        const image_error = caption_error || provider_error || tag_error || filename_error

        return (
            <div className={'image-edit-container w-100 text-center' + (image_error ? ' image-error' : '')}>
                {(!!image.src && (
                    <div className="position-relative hover-appear">
                        {/* {console.log('here', image.temp_src, image.src, !!image.src, image.temp_src||image.src)} */}
                        <Image {...image} />
                        <div
                            className="text-left w-100 target p-3 pb-0"
                            style={{ position: 'absolute', top: '0', left: '0', backgroundColor: 'rgba(255, 255, 255, .9)' }}
                        >
                            <label htmlFor={`image-alt-${image.id}`}>Caption</label>
                            <Input
                                id={`image-alt-${image.id}`}
                                className={'' + (caption_error ? ' image-error' : '')}
                                type="text"
                                value={image.alt}
                                onChange={(e) => this.setImageContent({ alt: e.target.value })}
                                article={this.props.article}
                            />
                            <label htmlFor={`image-href-${image.id}`} className="mt-2">
                                Target
                            </label>
                            <Input
                                id={`image-href-${image.id}`}
                                className={'' + (provider_error || tag_error ? ' image-error' : '')}
                                type="text"
                                value={image.href}
                                onChange={(e) => this.setImageContent({ href: e.target.value })}
                            />
                            <label htmlFor={`image-src-${image.id}`} className="mt-2">
                                Filename
                            </label>
                            <div className="input-group">
                                <Input
                                    id={`image-src-${image.id}`}
                                    className={'' + (filename_error ? ' image-error' : '')}
                                    type="text"
                                    value={this.getEditableFileName(image.temp_src || image.src)}
                                    onChange={(e) => {
                                        const static_end = this.getStaticPartInFilename(image.temp_src || image.src)
                                        this.setImageContent({ src: urlText(e.target.value).substring(0, 255 - static_end.length) + static_end })
                                    }}
                                    article={this.props.article}
                                    append={
                                        <div className="input-group-append">
                                            <span className="input-group-text">{this.getStaticPartInFilename(image.temp_src || image.src)}</span>
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                )) ||
                    null}
                {caption}
                <If condition={!image.src}>
                    <If condition={!base_64}>
                        {/* <input className="form-control" type="file" onChange={this.onUploadChange} /> */}
                        <FileInput type="file" onChange={this.onUploadChange} />
                    </If>
                    <If condition={base_64}>
                        <img alt="" className="img-fluid" src={base_64} onDragStart={(e) => e.preventDefault()} />
                    </If>
                </If>
            </div>
        )
    }
}
